import {getData, postData} from './redux_data';
import {
    GET_ALL_ARTICULOS,
    GET_TIPOS_ARTICULO,
    MODIFY_TIPO_ARTICULO,
    ADD_TIPO_ARTICULO,
    DELETE_TIPO_ARTICULO,
    UPDATE_TIPOS_ARTICULO,
} from '../constants/action_types';

export function getAllArticulos() {
    return getData('Cvtipoarticulos', GET_ALL_ARTICULOS);
}

export function getTiposArticulo() {
    return getData('vtipoarticulos', GET_TIPOS_ARTICULO);
}

export function modifyTipoArticulo(tipoArticulo) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_ARTICULO, payload: tipoArticulo });
    }
}

export function addTipoArticulo(tipoArticulo) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_ARTICULO, payload: tipoArticulo });
    }
}

export function removeTipoArticulo(tipoArticulo) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_ARTICULO, payload: tipoArticulo });
    }
}

export function updateTiposArticuloDB (tipoArticulo) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_TIPOS_ARTICULO, payload: tipoArticulo })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'vtipoarticulos/articulos', tipoArticulo,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_TIPOS_ARTICULO + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_tipo_articulo'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_tipo_articulo'
    //         });
    //     });
    // }

    return postData('vtipoarticulos/articulos', UPDATE_TIPOS_ARTICULO, tipoArticulo, 'Tipos de producto actualizados', undefined);

}

